import { connect } from 'react-redux'
import CuentaCliente from './CuentaCliente';
import { bindActionCreators } from 'redux';
import * as actions from "../actions/CuentaClienteActions";


const mapStateToProps = (state) => {
    return {
        data: state.vistaCliente.data,
        tarjetas: state.tarjetas
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);
const CuentaClienteContainer = connect(mapStateToProps, mapDispatchToProps)(CuentaCliente);

export default CuentaClienteContainer;